/**
 * Up to two letters for avatar fallbacks — first + last token from name when available,
 * otherwise local part of email.
 */
export function userInitials(displayName: string, email?: string | null): string {
  const trimmed = displayName.trim()
  if (trimmed) {
    const parts = trimmed.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
      return (parts[0]!.slice(0, 1) + parts[parts.length - 1]!.slice(0, 1)).toUpperCase()
    }
    return parts[0]!.slice(0, 2).toUpperCase()
  }

  const local = String(email || '')
    .trim()
    .split('@')[0]
    ?.trim()
  if (local && local.length >= 2) return local.slice(0, 2).toUpperCase()
  if (local?.length === 1) return local.toUpperCase()
  return '?'
}
